import React from "react";
import classes from "@/styles/become-an-affiliate/become-an-affiliate-main.module.css";
import { MdNote } from "react-icons/md";

interface Props {
  title?: string;
  icon?: JSX.Element;
  content: JSX.Element;
  color?: string;
  backgroundColor?: string;
}

const NoteSection = ({
  title,
  icon,
  content,
  color = "#81b64f",
  backgroundColor = "#e8f2df",
}: Props) => {
  return (
    <div className={`${classes.root}`}>
      <div className="d-flex gap-2">
        {icon ? icon : <MdNote size={30} />}
        <h4 className={classes.title}>{title ? title : "Note"}</h4>
      </div>
      <div className={classes.body}>{content}</div>
    </div>
  );
};

export default NoteSection;
